import React from 'react';
import { Flex, Text } from '@opendoor/bricks/core';
import Tooltip from '../shared/Tooltip';
import { OdProtosRealtyCommon_Source_Type } from '__generated__/athena';

interface AgentMlsInformationProps {
  agentFullName?: string | null;
  agentLicenseNumber?: string | null;
  brokerage?: string | null;
  mlsIdentifier?: string | null;
  mlsListingNumber?: string | null;
  detailApn?: string | null;
  buyerAgentPDP?: boolean | null;
  sourceType?: OdProtosRealtyCommon_Source_Type | null;
  agentEmail?: string | null;
  agentPhone?: string | null;
}

const AgentMlsInformation: React.FC<AgentMlsInformationProps> = ({
  agentFullName,
  agentLicenseNumber,
  brokerage,
  mlsIdentifier,
  mlsListingNumber,
  detailApn,
  buyerAgentPDP,
  sourceType,
  agentEmail,
  agentPhone,
}) => {
  return (
    <Flex flexDirection="column">
      {!buyerAgentPDP && (
        <Flex alignItems="flex-start">
          <Text fontSize={['s1', 's1', 's2', 's2']} fontWeight="semibold">
            Listed on the MLS. Provided by Opendoor Brokerage.{' '}
          </Text>
          <Tooltip analyticsName="cosmos-pdp-what-is-mls">
            <Text
              as="span"
              padding={[null, null, null, null, '5px']}
              fontSize={['s00', 's0', 's0', 's0', 's0']}
              fontWeight="semibold"
              color="neutrals0"
            >
              The Multiple Listing Service (MLS) is where agents and builders share homes available
              for sale across the US. Since Opendoor works with the MLS, you’ll see the same homes
              here as you would anywhere else.
            </Text>
          </Tooltip>
        </Flex>
      )}
      {sourceType === 'HOMEBUILDER' && mlsIdentifier && (
        <Text mt={[3, 4]} fontSize={['s00', 's00', 's0', 's0']} color="neutrals90">
          {mlsIdentifier?.toUpperCase()}
        </Text>
      )}
      {sourceType !== 'HOMEBUILDER' && (
        <Text mt={[3, 4]} fontSize={['s00', 's00', 's0', 's0']} color="neutrals90">
          {agentFullName} {agentLicenseNumber} {brokerage && `• ${brokerage}`}{' '}
          {mlsIdentifier?.toUpperCase()}
          {mlsListingNumber && `#${mlsListingNumber} `}
          {detailApn && `• APN: #${detailApn} `}
          {agentPhone && `• Phone: ${agentPhone} `}
          {agentEmail && `• Email: ${agentEmail}`}
        </Text>
      )}
    </Flex>
  );
};

export default AgentMlsInformation;
